import './theme/common.scss';

import Vue from 'vue';
import GlobalComponent, { popMgr } from './components/global';
import Router from './common/router';
import { initFormatFilter } from './common/format';
import directive from './common/directive';
import util from './common/util';
import global from './common/global';
import Data, { prepareData, updateRegisterUserType } from './common/data';
import Track from './common/track';
import mdLazy from './components/md-lazy.vue';
import signLog from './components/sign-log';
import {
    setLeadTag,
    loginOrRegister
} from './components/sign-log/socialstudio-lead-tag.js';
import questionNaire from './components/questionnaire';
import chat from './components/chat';
import getModule from './modules/index';
import modulesMap from './modules/module-map';
import mergeResource from './merge-resource';
import getStore from './store/index';
import { mapState } from 'vuex';
import { initOneStepLogin } from './common/google-login-one-step';
import {
    LOGIN,
    SET_PAGE,
    UPDATE_IS_MOBILE_SIZE,
    UPDATE_SEARCH_MOBILE_SIZE,
    UPDATE_WINDOW_SIZE,
    UPDATE_SEARCH_CENTER
} from './store/mutation-types';
import vow from './components/vow';
import onAutoPopup, { getAgreementTitleContent } from './common/autopopup.js';
import { findSearchBar } from './common/utils/find-search-bar';
import { registerStoreModule } from '@/store/register-module';
import { init as initRequirePhone } from './components/require-phone';
import plugin from './plugins';
import './common/rendebug';
import initCookieAuthority from './components/cookieAuthority';
import FastClick from 'fastclick';
// import advRegister from '@/components/sign-log/advertising-register/register.js';
import './loadFont';

import gaConversion from './common/ga-conversion';
import trackBingAd from './common/track/bing-ad';
// import AdvRegister from './components/advertising-register/register';
// AdvRegister.register();

if (util.isMobile) {
    FastClick.attach(document.body);
}

window.sitePrepareData = function () {
    return prepareData('fetch');
};
let SiteVue = (window.SiteVue = window.SiteVue || Vue);
SiteVue.use(initFormatFilter);
SiteVue.use(directive);
SiteVue.use(plugin);
SiteVue.prototype.$EventBus = new SiteVue();

Vue.config.warnHandler = window.rendebug.sendVueWarn;
Vue.config.errorHandler = function (err, vm, info) {
    window.rendebug.sendVueError(vm, err, info);
    console.error(err);
};
Vue.config.devtools = process.env.NODE_ENV !== 'production';
const replaceFontSize = (node, size) => {
    for (let i = 0, len = node.childNodes.length; i < len; i++) {
        const nodeItem = node.childNodes[i];
        if (nodeItem.nodeType === 1) {
            const fontSize = nodeItem.style.fontSize;
            if (fontSize) {
                nodeItem.style.fontSize = parseInt(fontSize) / size + 'em';
                replaceFontSize(nodeItem, parseInt(fontSize));
            } else {
                replaceFontSize(nodeItem, size);
            }
        }
    }
};

SiteVue.prototype.formatFontSize = function (value, size) {
    if (!size) {
        size = 14;
    }
    const reg = /font-size:\s*(\d+)px/g;
    const match = value.match(reg);
    if (match && match.length > 1) {
        const div = document.createElement('div');
        div.innerHTML = value;
        replaceFontSize(div, size);
        return div.innerHTML;
    } else {
        const newValue = value.replace(reg, function (a, b) {
            return `font-size: ${parseInt(b) / size}em`;
        });
        return newValue;
    }
};
GlobalComponent(SiteVue);
window.siteModulesMap = modulesMap;
const store = (window.siteStore = getStore(SiteVue));
store.commit(UPDATE_IS_MOBILE_SIZE, util.isMobileSize());
store.commit(UPDATE_SEARCH_MOBILE_SIZE, util.isMobileSize(800));
global.resize(() => {
    store.commit(UPDATE_WINDOW_SIZE);
    store.commit(UPDATE_IS_MOBILE_SIZE, util.isMobileSize());
    store.commit(UPDATE_SEARCH_MOBILE_SIZE, util.isMobileSize(800));
});

const defaultComponents = {
    'md-lazy': mdLazy
};

const getPageData = () => {
    let data = window.sitePageJSON;
    if (!data) {
        try {
            data = JSON.parse(
                document.getElementById('page-data').value.replace(/\n/g, '')
            );
        } catch (error) {
            console.error('resolve page data error.');
        }
    }
    return data;
};

const transformTheme = (name, theme, data, templateValue, page) => {
    const templateConfig = (modulesMap[name] || {}).templateConfig;
    if (templateConfig) {
        let newTheme = templateConfig[templateValue];
        if (util.isString(newTheme)) {
            data.theme = theme = newTheme;
        } else if (util.isFunction(newTheme)) {
            data.theme = theme =
                newTheme.call(templateConfig, theme, data, page) || data.theme;
        } else if (newTheme) {
            newTheme = newTheme[theme];
            if (util.isString(newTheme)) {
                data.theme = theme = newTheme;
            } else if (util.isFunction(newTheme)) {
                data.theme = theme =
                    newTheme.call(templateConfig, theme, data, page) ||
                    data.theme;
            }
        }
    }
    return theme;
};

const valueChangeMap = {
    string: '',
    array: [],
    obj: {}
};

const changeThemeValue = (theme, config, value) => {
    let flag = false;
    const themes = config.themes || [];
    if (config.exclude === undefined) {
        flag = true;
    } else if (config.exclude) {
        if (!themes.includes(theme)) {
            flag = true;
        }
    } else {
        if (themes.includes(theme)) {
            flag = true;
        }
    }
    if (flag && value) {
        if (config.isHtml) {
            value = value.replace(/style\s*?=\s*?(['"])([\s\S]*?)\1/g, '');
        } else {
            value = valueChangeMap[config.type] || '';
        }
    }
    return value;
};

const changeThemeData = (theme, config, data, key) => {
    const children = config.children;
    const type = config.type || 'string';
    if (children) {
        if (type === 'array') {
            if (data[key] && data[key].length) {
                for (let i = 0, len = data[key].length; i < len; i++) {
                    changeThemeData(theme, children, data[key], i);
                }
            }
        } else if (data[key]) {
            for (let i = 0, len = children.length; i < len; i++) {
                changeThemeData(theme, children[i], data[key], children[i].key);
            }
        }
    } else {
        data[key] = changeThemeValue(theme, config, data[key]);
    }
};

const transformData = (name, theme, data) => {
    const themeConfig = (modulesMap[name] || {}).themeConfig;
    if (themeConfig) {
        for (let key in themeConfig) {
            data[key] && changeThemeData(theme, themeConfig[key], data, key);
        }
    }
};

const houseThemeMap = {
    grid: 'grid-v3',
    'grid-': 'grid-v3',
    'grid-template1': 'grid-v1',
    'grid-standard': 'grid-v2',
    'grid-template4': 'grid-v3',
    list: 'list-v2',
    'list-': 'list-v2',
    'list-template1': 'list-v1',
    'list-standard': 'list-v2',
    'list-template4': 'list-v3'
};

const processModuleData = (data, page, _isPreview) => {
    let prefix = new Date().getTime(),
        themeConfig = Data.themeConfig || {},
        { templateValue, templateChangeTime, themeChangeTime } = themeConfig,
        updateTime = Data.updateTime || 0,
        isTemplateChange =
            !Data.ignoreTemplateChange && templateChangeTime > updateTime,
        isThemeChange = !Data.ignoreThemeChange && themeChangeTime > updateTime;
    data.forEach((item, index) => {
        if (item.vdata) return item;
        item = registerStoreModule(item, store);
        // const storeName = generateModuleName(item.name);
        let id = item.id || `${prefix}-${index}`,
            theme =
                item.data.theme ||
                (item.commonData && item.commonData.theme) ||
                'standard',
            itemData = Object.assign(
                {},
                item.commonData || {},
                item.data || {}
            );
        if (isTemplateChange) {
            theme = transformTheme(
                item.name,
                theme,
                itemData,
                templateValue,
                page
            );
        }
        if (isThemeChange) {
            transformData(item.name, theme, itemData);
        }
        if (item.name === 'md-house' && ['grid', 'list'].includes(theme)) {
            theme =
                houseThemeMap[theme + '-' + (itemData.style || '')] ||
                houseThemeMap[theme];
            itemData.theme = theme;
            itemData.style = '';
        }
        // 非landing page的情况下 更新globalData的registerUserType
        let globalData = window.sitePrepareData || window.sitePrepareData();
        if (!globalData.isLandingpage && item.name === 'md-detail-info') {
            let type;
            if (
                (type = util.getValueByPath(
                    item,
                    'data.listingDetail.info.purchaseType'
                ))
            ) {
                updateRegisterUserType(type);
            }
        }
        Object.assign(item, {
            id: id,
            module: item.module || true,
            visible: item.visible || false,
            moduleLoad: false,
            moduleRender: false,
            moduleMounted: false,
            loadingPs: null,
            noObserve: Data.lazyMode === false || itemData.noObserve,
            theme: theme,
            componentName: item.name + '-' + theme,
            vdata: {
                props: { id: id, sss: 'xxx' },
                key: id
                // $storeName: storeName
            },
            getVdata(self, item) {
                return { ...item.vdata };
            },
            data: itemData
        });
    });
    return data;
};

const getAppConfig = ({ el, moduleData, pageModuleMap = {}, oninit, page }) => {
    // eslint-disable-next-line no-useless-call
    const initConfig = (oninit && oninit.call(null, moduleData)) || {};
    const defaultConfig = {
        el: el || '#app',
        data: {
            moduleData,
            hideChat: false,
            scrollY: 0,
            beforeFullScreenScrollY: 0
        },
        store,
        computed: {
            allModuleMounted() {
                let mounted = this.moduleData.every(
                    item =>
                        item.moduleMounted || (item.visible && !item.moduleLoad)
                );
                if (mounted && window.siteAppVm)
                    window.siteAppVm.$emit('allModuleMounted');
                return mounted;
            },
            isHideChat() {
                const moduleStore = findSearchBar();
                return (
                    (this.hideChat ||
                        (moduleStore &&
                            moduleStore.state.layout === 'map' &&
                            (Data.pageKey === 'listing' ||
                                Data.pageKey === 'sold-listing'))) &&
                    !util.inCmsSetting
                );
            },
            ...mapState({
                user: state => state.user.user,
                loginStatus: state => state.user.loginStatus
            })
            // ...mapGetters('search', {
            //     search_mode: 'mode'
            // })
        },
        render(h) {
            let fromGlobalSetting = Data.fromGlobalSetting || false;
            let renderComponent = item => {
                if (
                    item.name !== 'module-loading' &&
                    item.module &&
                    !item.visible &&
                    !item.moduleLoad
                ) {
                    return h('md-lazy', {
                        on: {
                            visible: () => {
                                if (!item.visible) {
                                    const loadingPs = (item.loadingPs =
                                        getModule(
                                            this.$options.components,
                                            item.componentName,
                                            item.name,
                                            item.theme,
                                            this.pageModuleMap || pageModuleMap,
                                            this.modulesMap
                                        )
                                            .then(() => {
                                                if (
                                                    loadingPs === item.loadingPs
                                                ) {
                                                    item.loadingPs = null;
                                                    item.visible = true;
                                                    item.moduleLoad = true;
                                                }
                                            })
                                            .catch(error => {
                                                console.log(error);
                                                if (
                                                    loadingPs === item.loadingPs
                                                ) {
                                                    item.visible = true;
                                                }
                                            }));
                                }
                            }
                        },
                        key: item.id,
                        props: {
                            moduleName: item.name,
                            noObserve: item.noObserve,
                            hasLoadingPs: !!item.loadingPs
                        }
                    });
                } else if (item.name === 'module-loading') {
                    return h('md-lazy');
                } else if (item.moduleLoad) {
                    return h(
                        item.componentName,
                        item.getVdata
                            ? item.getVdata(this, item)
                            : { ...(item.vdata || {}) }, // 模块的数据
                        item.content || ''
                    );
                } else if (process.env.NODE_ENV === 'development') {
                    return h(
                        'div',
                        {
                            class: 'md-error'
                        },
                        `module ${item.name}(theme:${item.theme}) load fail`
                    );
                }
            };
            if (this.moduleData.length || fromGlobalSetting) {
                const templateValue = Data.template || '';
                var modules = this.moduleData;
                // 详情页弹窗不展示header
                // if (util.inPopDetailPage){
                //     modules = modules.filter(m => m.name !== 'md-header');
                // }
                return h(
                    'main',
                    Object.assign(
                        {
                            class:
                                'page-content ' +
                                templateValue +
                                (this.isHideChat ? ' hide-chat' : '')
                        },
                        initConfig.renderOptions
                    ),
                    modules.map(renderComponent)
                );
            } else {
                return h(
                    'div',
                    {
                        class: 'page-content'
                    },
                    [
                        h('div', { class: 'empty-container' }, [
                            h(
                                'p',
                                'This page is still under construction but will be available soon!'
                            )
                        ])
                    ]
                );
            }
        },
        created() {
            this.pageModuleMap = pageModuleMap;
            this.modulesMap = modulesMap;
        },
        mounted() {
            global.scroll(this.onscroll);
            document.addEventListener(
                'webkitfullscreenchange',
                this.fullscreenChange,
                false
            );
            if (this.user) {
                setLeadTag(
                    loginOrRegister.login,
                    this.user.id || '',
                    this.user.teamId || ''
                );
            } else {
                signLog.authByUrl(this);
            }
            // if (!util.isMobile && !util.inCms && !this.user) {
            //     if (advRegister.isShow()) {
            //         document.addEventListener(
            //             'mouseleave',
            //             this.mouseLeaveView,
            //             { once: true }
            //         );
            //     }
            // }
        },
        watch: {
            user(val) {
                if (
                    !this.user &&
                    Data.registration &&
                    Data.registration.autopopup &&
                    Data.registration.autopopup.triggerType == 4 &&
                    Data.registration.autopopup.type != 0 &&
                    util.getQueryField('isPopup') != 1
                ) {
                    setTimeout(() => {
                        this.openSignLog({
                            questionMsg: "I'm interested in this listing."
                        });
                    }, 1000 * 60);
                }
                // if (val && advRegister.isShow()) {
                //     document.removeEventListener(
                //         'mouseleave',
                //         this.mouseLeaveView
                //     );
                // }
                // chat.refreshUserInfo(this.user);
            }
        },
        methods: {
            fullscreenChange() {
                if (
                    !document.webkitIsFullScreen &&
                    this.beforeFullScreenScrollY
                ) {
                    global.scroll(this.beforeFullScreenScrollY);
                }
            },
            onscroll(scrollY) {
                if (
                    this.scrollY &&
                    scrollY === 0 &&
                    document.webkitIsFullScreen
                ) {
                    this.beforeFullScreenScrollY = this.scrollY;
                }
                this.scrollY = scrollY;
                if (util.isMobile) {
                    return;
                }
                // 距离底部200以内不展示chat
                var notFromBottom200 =
                    document.documentElement.clientHeight +
                        window.scrollY +
                        200 <
                    document.body.clientHeight;
                if (notFromBottom200) {
                    this.displayChat(true);
                } else {
                    this.displayChat(false);
                }
            },
            displayChat(isShow) {
                this.hideChat = !isShow;
            },
            updateChat(chatAndCaptureForm, logOutFlag) {
                chat.init(
                    this,
                    {
                        chatAndCaptureForm
                    },
                    logOutFlag
                );
            },
            closeChat() {
                chat.destroyChat();
            },
            openCaptureForm(options = {}, popReplace = false) {
                signLog.register(this, options, 'chatRegister', popReplace);
            },
            openSignLog(options = {}, popReplace = false) {
                this.signLogOptions = options;
                !this.user &&
                    signLog.register(
                        this,
                        options,
                        options.style,
                        popReplace,
                        true
                    );
            },
            closePop() {
                popMgr.closeAllPopWin();
            },
            changeSignLogStyle(style, popReplace = false) {
                this.signLogOptions &&
                    this.openSignLog(this.signLogOptions, popReplace);
            },
            openQuestionNaire(options = {}, type, popReplace = false) {
                this.questionNaireOptions = options;
                questionNaire.open(
                    this,
                    options,
                    type,
                    options.style,
                    popReplace
                );
            },
            changeQuestionNaireType(type, popReplace = false) {
                this.questionNaireOptions &&
                    this.openQuestionNaire(
                        this.questionNaireOptions,
                        type,
                        popReplace
                    );
            },
            refresh(moduleData, pos) {
                moduleData = processModuleData(moduleData, page, false);
                this.moduleData = moduleData;
                if (!isNaN(pos)) {
                    this.$nextTick(() => {
                        util.winScrollTop(pos);
                    });
                }
            },
            fillModuleDataProp(data, index) {
                const prefix = new Date().getTime();
                const id = data.id || `${prefix}-${index}`;
                const theme = data.data.theme || 'standard';
                data = registerStoreModule(data, store);
                // const storeName = generateModuleName(data.name);
                return Object.assign(data, {
                    id,
                    theme,
                    module: data.module || true,
                    visible: data.visible || false,
                    moduleLoad: false,
                    moduleRender: false,
                    moduleMounted: false,
                    componentName: data.name + '-' + theme,
                    vdata: {
                        props: { id: id },
                        key: id
                        // $storeName: storeName
                    },
                    getVdata(self, item) {
                        return { ...item.vdata };
                    },
                    data: Object.assign(
                        {},
                        data.commonData || {},
                        data.data || {}
                    )
                });
            },
            changeMouduleTheme(moduleId, theme) {
                const moduleData = this.moduleData,
                    idx = util.indexOf(moduleData, moduleId, 'id');
                let module = moduleData[idx];
                module.theme = theme;
                module.data.theme = theme;
                module.componentName = module.name + '-' + theme;
                module.visible = false;
                module.moduleLoad = false;
                module.moduleRender = false;
                module.moduleMounted = false;
                if (module.loadingPs) {
                    module.loadingPs = null;
                }
            },
            moduleRefresh(moduleId) {
                const moduleData = this.moduleData;
                const idx = util.indexOf(moduleData, moduleId, 'id');
                const prefix = new Date().getTime();
                const id = `${prefix}-${idx}`;
                moduleData[idx].id = id;
                moduleData[idx].vdata.props.id = id;
                moduleData[idx].vdata.key = id;
            },
            componentRefresh(moduleId, theme) {
                const moduleData = this.moduleData;
                const idx = util.indexOf(moduleData, moduleId, 'id');
                const componentName = moduleData[idx]['componentName'];
                this.$options.components[componentName] = null;
                // 重新载入组件
                this.changeMouduleTheme(moduleId, theme);
            },
            getCurPop: function () {
                return popMgr.getCurrent();
            },
            /**鼠标移出浏览器可视区时触发事件 CHIME-13995 */
            mouseLeaveView() {
                signLog.register(this, { mouseLeaveAllowClose: true });
            }
        },
        destroyed() {
            document.removeEventListener(
                'webkitfullscreenchange',
                this.fullscreenChange,
                false
            );
        },
        components: defaultComponents
    };
    return {
        mixins: [defaultConfig, initConfig.vueOptions || {}]
    };
};

const sitePageInit = (window.sitePageInit = (
    { el, oninit, pageData, globalData, router, unique } = {},
    pos
) => {
    // 页面初始化的时候要重置track handler
    Track.resetEventHandler();
    /*
     * 后端返回的这个pageData对应的是/assets/config/pages/<第几套模板>/<页面>.json 里面的json数据
     */
    pageData = pageData || getPageData();
    if (util.isNodePuppeteer && pageData.modules) {
        // 如果是 nodejs 的 puppeteer 渲染
        pageData.modules = pageData.modules.slice(0, 4);
    }
    globalData = prepareData(globalData);
    // 非idx套餐的landing-page要关闭问卷  1为非idx套餐
    // if(globalData?.evaluationSite == 1){
    //     console.log('None idx package close questionNaire');
    //     globalData.questionNaire instanceof Object && (globalData.questionNaire.inquiry = false);
    // }

    store.commit(LOGIN, { user: globalData.loginInfo || 0 });
    if (util.isReallyUser && !util.inCms) {
        // rendebug加载
        // window.rendebug.setOn(globalData.site && globalData.site.reportDebug);
        window.rendebug.setOn(Date.now() % 10 === 0);

        // // 障碍人士面板
        // (function() {
        //     var s = document.createElement('script'),
        //         e = !document.body
        //             ? document.querySelector('head')
        //             : document.body;
        //     s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
        //     s.async = true;
        //     s.onload = function() {
        //         acsbJS.init({
        //             statementLink: '',
        //             footerHtml: '',
        //             hideMobile: false,
        //             hideTrigger: false,
        //             language: 'en',
        //             position: 'left',
        //             leadColor: '#146FF8',
        //             triggerColor: '#146FF8',
        //             triggerRadius: '50%',
        //             triggerPositionX: 'left',
        //             triggerPositionY: 'bottom',
        //             triggerIcon: 'people',
        //             triggerSize: 'medium',
        //             triggerOffsetX: 20,
        //             triggerOffsetY: 20,
        //             mobile: {
        //                 triggerSize: 'small',
        //                 triggerPositionX: 'left',
        //                 triggerPositionY: 'center',
        //                 triggerOffsetX: 0,
        //                 triggerOffsetY: 0,
        //                 triggerRadius: '50%'
        //             }
        //         });
        //     };
        //     e.appendChild(s);
        // })();
    }
    store.commit(UPDATE_SEARCH_CENTER, globalData.searchCenter);
    if (window.sitePageAutoInit !== false && globalData.redirectUrl) {
        let mts = globalData.redirectUrl.match(/(?:\/\/([^/]+))?(\/[^?]+)/);
        if (
            mts &&
            ((mts[1] && mts[1] !== window.location.host) ||
                mts[2] !== window.location.pathname)
        ) {
            window.location = globalData.redirectUrl;
            return;
        }
    }
    // 页面上的hideChat配置转成showLauncher
    if (globalData.chatAndCaptureForm) {
        globalData.chatAndCaptureForm.showLauncher =
            !globalData.hideChat && globalData.chatAndCaptureForm.showLauncher;
    }
    // 这个customCode是自定义样式, 在cms->setting->Tools->Custom Style & Script里面可以配置, 是这个site下所有页面都会拿到的
    let customCode = globalData.customCode || {};
    if (customCode.style) {
        util.addStyle(customCode.style);
    }
    // util.addStyle('//static.chimeroi.com/servicetool-temp/site_font_block.css');
    // if (!isNaN(pos)) {
    // cms编辑界面走这里
    let styleEl = document.getElementById('page-style');
    if (styleEl) {
        styleEl.parentNode.removeChild(styleEl);
    }
    let pageCss = pageData?.css;
    if (pageCss) {
        util.addStyle(pageCss, false).setAttribute('id', 'page-style');
    }
    // }
    let page = pageData?.page,
        moduleData = processModuleData(pageData.modules, page, util.inCms);

    if (!util.isReallyUser && util.isMobile) {
        // 移动端跑分工具, 只加载3个模块
        moduleData.splice(3);
    }
    store.commit(SET_PAGE, {
        page,
        ...globalData
    });
    let mergeKey = globalData.mergeResourceKey || '',
        mergeFun = mergeResource[mergeKey],
        pageModuleMap,
        promiseArr = [];

    //如果浏览器不支持IntersectionObserver则添加polyfill
    if (!window.IntersectionObserver) {
        promiseArr.push(
            util.addScript(
                '//static.chimeroi.com/lib/polyfill/IntersectionObserver.js',
                true,
                true
            )
        );
    }
    if (!window.ResizeObserver) {
        promiseArr.push(
            util.addScript(
                '//static.chimeroi.com/lib/polyfill/ResizeObserver.js',
                true,
                true
            )
        );
    }

    if (mergeFun && mergeFun(moduleData)) {
        promiseArr.push(
            mergeFun(moduleData).then(pageModule => {
                pageModuleMap = pageModule.default;
            })
        );
    }
    try {
        // 移除详情页弹框父窗口的loading
        if (util.inPopDetailPage) {
            window.parent.__curDetailPop.setLoading(false);
        }
    } catch (e) {}

    if (promiseArr.length) {
        return Promise.all(promiseArr).then(() => {
            return initSiteAppVm(
                page,
                pageModuleMap,
                moduleData,
                pos,
                el,
                oninit,
                router,
                globalData,
                pageData,
                customCode,
                unique
            );
        });
    } else {
        return Promise.resolve(
            initSiteAppVm(
                page,
                pageModuleMap,
                moduleData,
                pos,
                el,
                oninit,
                router,
                globalData,
                pageData,
                customCode,
                unique
            )
        );
    }
});

function initSiteAppVm(
    page,
    pageModuleMap,
    moduleData,
    pos,
    el,
    oninit,
    router,
    globalData,
    pageData,
    customCode,
    unique
) {
    if (window.siteAppVm && !unique) {
        document.body.className = 'site ' + page;
        if (util.isMobile) {
            document.body.classList.add('mobile');
        }
        window.siteAppVm.pageModuleMap = pageModuleMap || {};
        window.siteAppVm.closePop();
        window.siteAppVm.refresh(moduleData, pos);
    } else {
        window.siteAppVm = new SiteVue(
            getAppConfig({
                el,
                moduleData,
                pageModuleMap,
                oninit,
                page
            })
        );
        if (
            router === false ||
            globalData?.site?.singlePage === false ||
            util.inApp
        ) {
            Router.multiPageInit(window.siteAppVm);
        } else if (router !== false && globalData?.site?.singlePage !== false) {
            // Router.init(sitePageInit, window.siteAppVm);
            Router.multiPageInit(window.siteAppVm); // 临时方案,需要服务端将参数放入全局数据的 URI_REQUEST_PARAMS
        }
        // 请求cookie
        initCookieAuthority(SiteVue, store);
        initRequirePhone(window.siteAppVm);
    }

    const closeCallback = () => {
        let { loginCallback } = Data.scheduleAnchor;
        loginCallback &&
            loginCallback() &&
            (Data.scheduleAnchor.loginCallback = null);
    };

    if (util.getQueryField('isPopup') == 1) {
        // 没登录强弹登录框
        store
            .dispatch('getUser', {
                checkOtherIframe: true,
                fromGlobal: true
            })
            .then(isLogin => {
                if (!isLogin) {
                    window.siteAppVm.openSignLog({
                        onClose: () => closeCallback(),
                        onsuccess: () => closeCallback(),
                        allowClose:
                            globalData.registration?.autopopup?.allowClose
                    });
                }
            });
    } else if (window.sitePageAutoInit !== false) {
        // window.siteAppVm.isVow = false;
        let options = getAgreementTitleContent(
                globalData.mlsOrgs,
                globalData.pageKey,
                pageData
            ),
            isHasPopupRule =
                (globalData.registration &&
                    globalData.registration.autopopup) ||
                util.getCookie('source');
        // eslint-disable-next-line no-inner-declarations
        function popUpFunc() {
            store
                .dispatch('getUser', {
                    checkOtherIframe: true,
                    fromGlobal: true
                })
                .finally(() => {
                    console.log(globalData.registration.autopopup);
                    onAutoPopup(
                        window.siteAppVm,
                        Object.assign(globalData.registration.autopopup, {
                            closeCallback
                        })
                    );
                    globalData.googleAppId &&
                        globalData.enableGSI !== false &&
                        initOneStepLogin(globalData.googleAppId, store);
                });
        }
        if (options) {
            vow.open(options, 0, () => {
                if (isHasPopupRule) {
                    popUpFunc();
                }
            });
        } else if (isHasPopupRule) {
            popUpFunc();
        }
    }
    if (pageData.script) {
        new Function(pageData.script).call(window.siteAppVm);
    }
    if (customCode.script) {
        try {
            new Function(customCode.script)();
        } catch (e) {
            console.error('Custom Script Error: ' + e);
        }
    }
    if (
        globalData.siteStatus === 0 &&
        document.body.className.indexOf('pending') === -1
    ) {
        document.body.className += ' pending';
    }

    if (window.siteAppVm && !unique) {
        window.siteAppVm.$EventBus.$emit('siteTrack', {
            trackType: 'page-change'
        });
    }

    if (util.isReallyUser) {
        // crm traffic report 统计数据
        new Image().src = '/0.gif?u=' + (globalData.requestId || '');
    }

    chat.init(window.siteAppVm, globalData);
    return window.siteAppVm;
}

if (window.sitePageAutoInit !== false) {
    if (document.querySelector('.preview')) {
        //Lighthouse直接使用预览图片, 干掉这个
        document.querySelector('.preview').remove();
    }
    Track.prepare();
    sitePageInit();

    //css var变量兼容处理
    const isNativeSupport =
        window.CSS && window.CSS.supports && window.CSS.supports('(--a: 0)');
    if (!isNativeSupport) {
        util.addScript(
            'https://static.chimeroi.com/servicetool-temp/site-cdn/css-vars-ponyfill.min.js',
            true
        ).then(() => {
            window.cssVars &&
                window.cssVars({
                    include:
                        'style,link[href*="/static/"],link[type="text/css"][href*="/site-static/"],link[type="text/css"][href*="static.chimeroi.com"]',
                    watch: true
                });
        });
    }
}

// ga conversion
gaConversion();

// bing 埋点
trackBingAd();

// 设置时区
util.setCookie('timezone', util.getTimeZone());

// social 的参数抓取
if (util.getQueryField('cpclid')) {
    util.setCookie('cpclid', util.getQueryField('cpclid'), 7);
}

export default sitePageInit;
// eslint-disable-next-line no-undef
console.log('__BUILD_ID__', __BUILD_ID__);
// eslint-disable-next-line no-undef
console.log('__chime env__', process.env.CHIME_ENV, global);
if (
    document.currentScript?.src &&
    typeof document.currentScript.src === 'string'
) {
    console.log(
        'CODE CDN :',
        document.currentScript.src.startsWith('https://static.chimeroi.com')
    );
}
